import request from '@/router/axios'

let urlPrefix = '/api/lab/statistics'

/**
 * 教学统计数据
 * @param {Number}} teacherId 教师ID
 */
export const getLabTeacherS = teacherId => {
    return request(`${urlPrefix}/teacher/${teacherId}`)
};

/**
 * 获取实验记录的时长与次数
 * @param {Object} params
 */
export const getLessonExpLogSta = (params = {}) => {
    return request(`${urlPrefix}/lesson/exp/log`, {params})
};

/**
 * 平台统计查询
 * @param {Object} params
 * @param {Number} params.year
 * @param {Number} params.month
 * @param {Number} params.day
 * @returns {Promise}
 */
export function statisticPlatformKpi(params = {}) {
    return request(`${urlPrefix}/StatisticPlatformKPI`, {
        params
    })
}

/**
 * 某课堂的统计信息
 * @param {String} uid 课堂UID
 */
export const getLessonStatistics = (uid, params = {}) => {
    return request(`${urlPrefix}/lesson/${uid}`, { params })
}

export const getTopClassList = (len = 10, params = {}) => {
    return request(`${urlPrefix}/lesson/topList/${len}`, { params })
}

export const getLabStatistical = () => {
    return request(`${urlPrefix}/lab`)
}

export const getLabUserStatistical = (userId, params = {}) => {
    return request(`${urlPrefix}/lesson/user/${userId}`, { params })
}

export const userScoreRankingList = (params = {}) => {
    return request(`${urlPrefix}/lesson/exp/userRanking`, { params })
}
